import React, { ComponentType } from 'react'

export type HighlightChartProps = {
  url: string
  title: string
  renderImage?: ComponentType<HighlightChartRenderImageProps>
}

export type HighlightChartRenderImageProps = Partial<HighlightChartProps>

const renderImageDefault = ({
  url = '',
  title = ''
}: HighlightChartRenderImageProps) => (
  <iframe
    allowFullScreen
    frameBorder="0"
    scrolling="no"
    src={url}
    title={title}
  />
)

export const HighlightChart = ({
  renderImage: Img = renderImageDefault,
  ...props
}: HighlightChartProps) => (
  <div className="frw-iframe-wrapper--1">
    <Img {...props} />
  </div>
)
export default HighlightChart
